import React, { PureComponent } from 'react';
import styled, {css} from 'styled-components';

export interface Props {
  icon: string;
  size: number;
  color: string;
  className?: string;
  onClick?: (...args: any[]) => void;
}

export default class Icon extends PureComponent<Props, any> {
    render() {
        return (
            <SVG
                onClick={this.props.onClick}
                className={this.props.className}
                width={`${this.props.size}px`}
                height={`${this.props.size}px`}
                viewBox="0 0 1024 1024"
            >
              <path d={this.props.icon} fill={this.props.color}/>
            </SVG>
        );
    }
}

const SVG = styled.svg`
    display: 'inline-block';
    vertical-align: 'middle';
`;
